import React, { useEffect, useState } from 'react';
import { Container, Text, Loader, Alert, Center, Stack } from '@mantine/core';
import { IconCheck, IconX } from '@tabler/icons-react';
// import { lucidAuthService } from '../../../shared/services/lucidAuthService';

const LucidAuthCallback = () => {
  const [status, setStatus] = useState('processing'); // processing, success, error
  const [message, setMessage] = useState('Processing authentication...');

  useEffect(() => {
    const handleCallback = () => {
      try {
        console.log('LucidAuthCallback: Processing callback...');
        
        // Get the current URL and extract parameters
        const currentUrl = window.location.href;
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        const state = urlParams.get('state');
        
        console.log('LucidAuthCallback: Current URL:', currentUrl);
        console.log('LucidAuthCallback: Extracted code and state:', { code: code ? 'present' : 'missing', state });
        
        setStatus('success');
        setMessage('Authentication successful! Closing window...');

        // Notify parent window to handle the callback (parent has access to stored state)
        if (window.opener) {
          console.log('LucidAuthCallback: Notifying parent window...');
          window.opener.postMessage({
            type: 'LUCID_AUTH_SUCCESS',
            code: code,
            state: state,
            url: currentUrl
          }, window.location.origin);
          
          // Close popup after a brief delay
          setTimeout(() => {
            window.close();
          }, 1000);
        } else {
          // If not in a popup, show message to close manually
          setMessage('Authentication successful! You can close this window.');
        }

      } catch (error) {
        console.error('LucidAuthCallback: Error processing callback:', error);
        setStatus('error');
        setMessage(`Authentication failed: ${error.message}`);

        // Notify parent window of error if this is a popup
        if (window.opener) {
          window.opener.postMessage({
            type: 'LUCID_AUTH_ERROR',
            error: error.message
          }, window.location.origin);
        }
      }
    };

    // Check for error in URL first
    const urlParams = new URLSearchParams(window.location.search);
    const error = urlParams.get('error');
    const code = urlParams.get('code');

    if (error) {
      console.error('LucidAuthCallback: OAuth error in URL:', error);
      setStatus('error');
      setMessage(`Authentication failed: ${urlParams.get('error_description') || error}`);
      
      if (window.opener) {
        window.opener.postMessage({
          type: 'LUCID_AUTH_ERROR',
          error: urlParams.get('error_description') || error
        }, window.location.origin);
      }
    } else if (code) {
      console.log('LucidAuthCallback: Authorization code found, processing...');
      handleCallback();
    } else {
      console.error('LucidAuthCallback: No code or error in URL');
      setStatus('error');
      setMessage('No authorization code received');
      
      if (window.opener) {
        window.opener.postMessage({
          type: 'LUCID_AUTH_ERROR',
          error: 'No authorization code received'
        }, window.location.origin);
      }
    }
  }, []);

  const getStatusColor = () => {
    switch (status) {
      case 'success': return 'green';
      case 'error': return 'red';
      default: return 'blue';
    }
  };

  const getStatusIcon = () => {
    switch (status) {
      case 'success': return <IconCheck size="2rem" />;
      case 'error': return <IconX size="2rem" />;
      default: return <Loader size="lg" />;
    }
  };

  return (
    <Container size="sm" style={{ height: '100vh' }}>
      <Center style={{ height: '100%' }}>
        <Stack align="center" gap="lg">
          <div style={{ color: getStatusColor() === 'green' ? '#40c057' : getStatusColor() === 'red' ? '#fa5252' : '#228be6' }}>
            {getStatusIcon()}
          </div>
          
          <Text size="xl" fw={600} align="center">
            Lucid Charts Authentication
          </Text>
          
          {status === 'error' ? (
            <Alert color="red" title="Authentication Error">
              {message}
            </Alert>
          ) : status === 'success' ? (
            <Alert color="green" title="Success">
              {message}
            </Alert>
          ) : (
            <Text align="center" color="dimmed">
              {message}
            </Text>
          )}

          {window.opener && status !== 'processing' && (
            <Text size="sm" color="dimmed" align="center">
              This window will close automatically...
            </Text>
          )}
        </Stack>
      </Center>
    </Container>
  );
};

export default LucidAuthCallback;